export default __webpack_public_path__ + "static/media/bell.1e852fb8.svg";